import { Briefcase, Wifi, Smartphone, Zap, BarChart3, MessageCircle, Phone } from "lucide-react";
import { Reveal } from "../landing/Reveal";
import { CONTACT } from "../../lib/site";

const waBusiness = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
  "Ciao Alessandro! Ho una Partita IVA e vorrei una consulenza business gratuita sulle utenze aziendali."
)}`;

const features = [
  { icon: Wifi, title: "Internet aziendale", desc: "Connettività dedicata e affidabile per la tua attività." },
  { icon: Smartphone, title: "SIM aziendali", desc: "Piani mobile business per te e il tuo team." },
  { icon: Zap, title: "Luce e Gas business", desc: "Forniture ottimizzate sui consumi reali dell'azienda." },
  { icon: BarChart3, title: "Quadro completo delle spese", desc: "Analizziamo tutte le utenze per capire dove risparmiare." },
];

export const Business = () => (
  <section id="business" data-testid="business-section" className="relative bg-ink text-white py-24 md:py-32 overflow-hidden">
    <div className="pointer-events-none absolute -top-24 right-0 w-[34rem] h-[34rem] rounded-full bg-brand/20 blur-[150px]" />
    <div className="relative max-w-4xl mx-auto px-6 md:px-12">
      <div>
        <Reveal>
          <div className="inline-flex items-center gap-2 rounded-full border border-brand/40 bg-brand/10 px-4 py-1.5 text-xs font-bold tracking-[0.15em] uppercase text-brand">
            <Briefcase className="w-4 h-4" /> Partite IVA · Business
          </div>
          <h2 className="font-display font-extrabold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-6 leading-[1.08]">
            Una consulenza business,<br /><span className="text-brand">su misura per la tua attività.</span>
          </h2>
          <p className="mt-6 text-lg text-white/60 max-w-xl leading-relaxed">
            Analizziamo insieme tutte le utenze aziendali per darti un quadro completo di quanto spendi — e di quanto puoi risparmiare.
            Gratis e senza impegno, <span className="text-white font-semibold">direttamente con me, Alessandro.</span>
          </p>
        </Reveal>

        <div className="mt-9 grid sm:grid-cols-2 gap-4">
          {features.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.06}>
              <div data-testid={`business-feature-${i}`} className="h-full rounded-2xl bg-white/[0.03] border border-white/10 p-5 hover:border-brand/40 transition-colors">
                <f.icon className="w-6 h-6 text-brand" strokeWidth={1.5} />
                <h3 className="font-display font-semibold text-lg mt-3">{f.title}</h3>
                <p className="mt-1 text-sm text-white/55 leading-relaxed">{f.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a href={waBusiness} target="_blank" rel="noreferrer" data-testid="business-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand hover:bg-brand-hover px-8 py-4 font-semibold transition-all duration-200 hover:scale-[1.03] shadow-lg shadow-brand/30">
              <MessageCircle className="w-5 h-5" /> Prenota la consulenza business
            </a>
            <a href={`tel:${CONTACT.phoneMobile.tel}`} data-testid="business-call-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 hover:border-white hover:bg-white/5 px-8 py-4 font-semibold transition-all duration-200">
              <Phone className="w-5 h-5" /> Chiama Alessandro
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
